
import { DatePicker } from "v-calendar";
import { computed, defineComponent, ref } from "vue";
import { toDate } from "date-fns-tz";

export default defineComponent({
	props: {
		modelValue: Date,
		minDate: {
			type: Date,
		},
		maxDate: Date,
		disabled: Boolean,
		availableDates: Array,
	},
	components: {
		DatePicker,
	},
	setup(props, { emit }) {
	
		const datePickerRef = ref(HTMLElement);

		const handleFromPage = (e: any) => {
			emit("fromPage", e);
		};

		const inputValue = computed({
			get(): Date | undefined {
				return props.modelValue ?? new Date();
			},
			set(value: Date | undefined) {
				emit("update:modelValue", toDate(value ?? new Date(), { timeZone: 'Europe/London'}));
			},
		});

		return { inputValue, datePickerRef, handleFromPage };
	},
});
